import fetchJson from './fetchJson'

const baseUri = 'https://manager.web-troc.com/apiDeposant';

/**
 * @param {String} [lsKey]
 *
 * @return {Object}
 */
export default function getAuthentication (lsKey = 'user') {
  return {

    /**
     * @return {?Object}
     */
    getConnectedUser () {
      return new Promise((resolve) => {
        const user = localStorage.getItem(lsKey)

        let result = Promise.resolve(user ? JSON.parse(user) : null);
        resolve(result)
      })
    },

    /**
     * @returns {*}
     */
    async verifUrl (url) {
      const response = await fetchJson(baseUri + '/verif-url', {
        body: {
          url: url
        },
        method: 'POST'
      })

      return response
    },

    /**
     * @param token
     * @returns {Promise<any>}
     */
    async getDepotVentes (token) {
      const depotVentes = await fetchJson(baseUri + '/depot-ventes', {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      return depotVentes
    },

    /**
     * @param {String} email
     * @param {String} idSoft
     * @param {String} depotVente
     * @param {String} marque
     *
     * @return {?Object}
     */
    async login (email, idSoft, depotVente, marque) {
      const response = await fetchJson(baseUri + '/login', {
        body: {
          deposantUsername: email,
          deposant: idSoft,
          depotVente: depotVente,
          marque: marque
        },
        method: 'POST'
      })

      return response
    },

    logout () {
      localStorage.removeItem(lsKey)

      return Promise.resolve()
    }
  }
}
